<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Order</span></h5>
              <h3 class="my-3">
                <span>
                  {{ getTotalSales | currency }}
                </span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-warning">Not progress</span></h5>
              <h3 class="my-3">
                <span>
                  {{ getTotalProgressZero | currency }}
                </span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-info">On progress</span></h5>
              <h3 class="my-3">
                <span>
                  {{ getTotalOnProgress | currency }}
                </span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Complete</span></h5>
              <h3 class="my-3">
                <span>
                  {{ getTotalProgressComplete | currency }}
                </span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h5>Sale Order</h5>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <div class="form-inline ml-auto">
                    <div class="button-group">
                        <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                          <i class="fa fa-filter" aria-hidden="true"></i>
                            Filter
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu p-2" >
                          <span>Company:</span>
                          <li v-for="c in companyList" :key="c.id">
                            <a href="#" class="small" tabIndex="-1">
                              <input type="checkbox" :value="c.company_no" v-model="filterCompany"/>&nbsp; {{ c.name }}
                            </a>
                          </li>
                          <div class="dropdown-divider"></div>
                          <span>Progress:</span>
                          <li>
                            <a href="javascript:void(0)" class="small" tabindex="-1"><input type="checkbox" :value="0" v-model="filterProgress"/>&nbsp; Not Progress</a>
                          </li>
                          <li>
                            <a href="javascript:void(0)" class="small" tabindex="-1"><input type="checkbox" :value="10" v-model="filterProgress"/>&nbsp; On Progress</a>
                          </li>
                          <li>
                            <a href="javascript:void(0)" class="small" tabindex="-1"><input type="checkbox" :value="100" v-model="filterProgress"/>&nbsp; Complete</a>
                          </li>
                        </ul>
                        <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addSales">
                          <i class="fa fa-plus" aria-hidden="true"></i> New
                        </button>
                        <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshSales">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                        </button>
                        rows:
                        <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                          <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                        </select>
                        <span class="mr-1">
                          Total rows: <b>{{ filterData.length }}</b>
                        </span>
                        <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshSales"></date-picker>
                    </div>
                    <div class="form-group mx-sm-3 mb-2">
                        <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                    </div>
                    <span class="mr-1">{{ currentPage }} / {{ pageLength }}</span>
                    <nav aria-label="Page navigation example" class="pull-right">
                        <ul class="pagination">
                            <li class="page-item">
                                <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="prevPage">
                                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                                </a>
                            </li>
                            <li class="page-item">
                                <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="nextPage">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                </a>
                            </li>
                        </ul>
                    </nav>
                  </div>
                  <table class="table table-item mb-0 table-sm table-hover">
                      <thead>
                          <tr>
                              <th>
                                <label class="form-checkbox">
                                  <input type="checkbox" v-model="selectAll" @click="select">
                                  <i class="form-icon"></i>
                                </label>
                              </th>
                              <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                  {{ t.name }}
                                  <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                              </th>
                          </tr>
                      </thead>
                      <tbody>
                        <tr v-if="filterData.length < 1">
                          <td colspan="15" style="text-align: center;"><i>No Data</i></td>
                        </tr>
                        <tr v-for="u in filterData" v-bind:key="u.id" style="cursor: pointer">
                          <td>
                            <label class="form-checkbox">
                              <input type="checkbox" :value="u.id" v-model="selected">
                              <i class="form-icon"></i>
                            </label>
                          </td>
                          <td @click="editSales(u.id)">
                            <span class="badge badge-success" v-if="u.status === 'open'">{{ u.status }}</span>
                            <span class="badge badge-primary" v-else-if="u.status === 'approved'">{{ u.status }}</span>
                            <span class="badge badge-warning" v-else>{{ u.status }}</span>
                          </td>
                          <td @click="editSales(u.id)">
                            <span v-if="u.progress === 100" class="badge badge-success">{{ u.progress }} %</span>
                            <span v-else-if="u.progress === 0" class="badge badge-warning">{{ u.progress }} %</span>
                            <span v-else class="badge badge-info">{{ u.progress }} %</span>
                          </td>
                          <td @click="editSales(u.id)"><b>{{ u.project_name }}</b></td>
                          <td @click="editSales(u.id)"><b>{{ u.order_no }}</b></td>
                          <td @click="editSales(u.id)">
                            <ul>
                              <li v-for="(s, idx) in u.sale_no" :key="idx">
                                <b>{{ s }}</b>
                              </li>
                            </ul>
                          </td>
                          <td @click="editSales(u.id)">{{ u.order_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td @click="editSales(u.id)" :class="u.overdue">{{ u.order_due_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td @click="editSales(u.id)">{{ u.branch }}</td>
                          <td @click="editSales(u.id)">{{ u.customer }}</td>
                          <td @click="editSales(u.id)">{{ u.salesman }}</td>
                          <td @click="editSales(u.id)">{{ u.taxes }}</td>
                          <td @click="editSales(u.id)">{{ u.tax | currency }}</td>
                          <td @click="editSales(u.id)">{{ u.total | currency }}</td>
                          <td @click="editSales(u.id)">{{ u.company }}</td>
                        </tr>
                      </tbody>
                  </table>
                </div>
              </div>
            </div>
        </div>
      </div>
      <!-- <pre>{{ filterCompany }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import { saleOrderUrl, getHeader } from '../../config'

export default {
  name: 'SalesList',
  components: {
    Loading,
    DatePicker
  },
  data () {
    const date = new Date()
    // var firstDay = new Date(date.getFullYear(), date.getMonth(), parseFloat(date.getDate()) - 7)
    // var lastDay = new Date()
    // const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    const date1 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    const date2 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    return {
      filterProgress: [],
      filterCompany: [],
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status'
      }, {
        name: 'Progress',
        prop: 'progress'
      }, {
        name: 'SP No.',
        prop: 'project_name'
      }, {
        name: 'Order No',
        prop: 'order_no'
      }, {
        name: 'Sale No',
        prop: 'sale_no'
      }, {
        name: 'Date',
        prop: 'order_date'
      }, {
        name: 'Due Date',
        prop: 'order_due_date'
      }, {
        name: 'Branch',
        prop: 'branch'
      }, {
        name: 'Customer',
        prop: 'customer'
      }, {
        name: 'Sales Person',
        prop: 'salesman_id'
      }, {
        name: 'Tax',
        prop: 'tax_id'
      }, {
        name: 'Tax Amount',
        prop: 'tax'
      }, {
        name: 'Total',
        prop: 'total'
      }, {
        name: 'Company',
        prop: 'company_no'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshSales()
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList
    }),
    getTotalProgressZero () {
      var count = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        if (array[i].progress === 0) {
          count += 1
        }
      }
      return count
    },
    getTotalOnProgress () {
      var count = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        if (array[i].progress > 0 && array[i].progress < 100) {
          count += 1
        }
      }
      return count
    },
    getTotalProgressComplete () {
      var count = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        if (array[i].progress === 100) {
          count += 1
        }
      }
      return count
    },
    getTotalSales: function () {
      var num = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        num += parseFloat(array[i].total)
      }
      return num
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        if (this.filterCompany.length > 0) {
          for (let i = 0; i < this.filterCompany.length; i++) {
            if (d.company_no === this.filterCompany[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        if (this.filterProgress.length > 0) {
          for (let i = 0; i < this.filterProgress.length; i++) {
            if (this.filterProgress[i] === 0) {
              if (d.progress === 0) {
                return d
              }
            } else if (this.filterProgress[i] === 10) {
              if (d.progress > 0 && d.progress < 100) {
                return d
              }
            } else if (this.filterProgress[i] === 100) {
              if (d.progress === 100) {
                return d
              }
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editSales (id) {
      this.$Progress.start()
      this.loader.isLoading = true
      axios.get(saleOrderUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$emit('editSales', response.data.data)
        })
        .catch(error => {
          this.$Progress.fail()
          this.loader.isLoading = false
          console.log(error.response)
          this.$swal(
            'Error!!!',
            error.response.data.message,
            'error'
          )
        })
    },
    addSales () {
      this.$emit('newSales', true)
    },
    refreshSales () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = saleOrderUrl + '?begin=' + begin + '&end=' + end
      console.log(url)
      axios.get(url, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            'Cannot Get Sale Order Index',
            'error'
          )
        })
    }
  }
}
</script>

<style>
.overdue {
  background-color: rgb(185, 93, 93);
  color: white;
}
</style>
